import { Service, inject } from '@angular/core'
import {
  CancelEventBody,
  GetManagedEventsResponse,
  ManagedEvent,
  CreateEventBody,
  EditEventBody,
  EditEventSeriesBody,
  EditEventSeriesResponse,
  SetEventActiveBody,
  DeleteEntityResponse,
  GetManagedEventsQuery,
  JoinEventSeriesBody,
  SeriesOption,
} from '@seiri/shared/common'
import { ApiService } from '../api.service'

@Service()
export class ManageEventApiService {
  private readonly api = inject(ApiService)

  getManagedEvents(entityId: string, query: GetManagedEventsQuery, init?: RequestInit) {
    const url = this.api.createURL(`manage/entities/${entityId}/events`)
    url.search = this.api.toQueryParams(query)
    return this.api.protectedFetchJson<GetManagedEventsResponse>(url, { ...init })
  }

  getManagedEvent(entityId: string, eventId: string, init?: RequestInit) {
    return this.api.protectedFetchJson<ManagedEvent>(`manage/entities/${entityId}/events/${eventId}`, { ...init })
  }

  createEvent(entityId: string, body: CreateEventBody, init?: RequestInit) {
    return this.api.protectedFetchJson<ManagedEvent>(`manage/entities/${entityId}/events`, {
      method: 'POST',
      body: JSON.stringify(body),
      ...init,
    })
  }

  editEvent(entityId: string, eventId: string, body: EditEventBody, init?: RequestInit) {
    return this.api.protectedFetchJson<ManagedEvent>(`manage/entities/${entityId}/events/${eventId}`, {
      method: 'PATCH',
      body: JSON.stringify(body),
      ...init,
    })
  }

  editEventSeries(entityId: string, eventId: string, body: EditEventSeriesBody, init?: RequestInit) {
    return this.api.protectedFetchJson<EditEventSeriesResponse>(
      `manage/entities/${entityId}/events/${eventId}/series`,
      { method: 'PATCH', body: JSON.stringify(body), ...init },
    )
  }

  getSeriesOptions(entityId: string, eventId: string, init?: RequestInit) {
    return this.api.protectedFetchJson<SeriesOption[]>(`manage/entities/${entityId}/events/${eventId}/series-options`, {
      ...init,
    })
  }

  joinEventSeries(entityId: string, eventId: string, body: JoinEventSeriesBody, init?: RequestInit) {
    return this.api.protectedFetchJson<ManagedEvent>(`manage/entities/${entityId}/events/${eventId}/series`, {
      method: 'PUT',
      body: JSON.stringify(body),
      ...init,
    })
  }

  deleteEvent(entityId: string, eventId: string, init?: RequestInit) {
    return this.api.protectedFetchJson<DeleteEntityResponse>(`manage/entities/${entityId}/events/${eventId}`, {
      method: 'DELETE',
      ...init,
    })
  }

  setEventActive(entityId: string, eventId: string, body: SetEventActiveBody, init?: RequestInit) {
    return this.api.protectedFetchJson<ManagedEvent>(`manage/entities/${entityId}/events/${eventId}/active`, {
      method: 'PUT',
      body: JSON.stringify(body),
      ...init,
    })
  }

  cancelEvent(entityId: string, eventId: string, body: CancelEventBody, init?: RequestInit) {
    return this.api.protectedFetchJson<ManagedEvent>(`manage/entities/${entityId}/events/${eventId}/cancel`, {
      method: 'POST',
      body: JSON.stringify(body),
      ...init,
    })
  }
}
